import { Component } from '@angular/core';
import { AssignDistributorStaffComponent } from '../assign-distributor-staff/assign-distributor-staff.component';
import { ListDistributorStaffComponent } from '../list-distributor-staff/list-distributor-staff.component';

@Component({
    selector: 'app-distributor-staff',
    templateUrl: './distributor-staff.component.html',
    styleUrls: ['./distributor-staff.component.scss'],
    imports: [AssignDistributorStaffComponent, ListDistributorStaffComponent]
})
export class DistributorStaffComponent {

    distributorData: any;

    ngOnInit() {
        this.distributorData = history.state.distributorData;
    }
}
